import PropTypes from 'prop-types'
import styles from './pageSection.module.scss'

const PageSection = ({ children, className = '', ...rest }) => {
  return (
    <section className={`${styles.pageSection} ${className}`} {...rest}>
      {children}
    </section>
  )
}

PageSection.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
}

export { PageSection }
